<template>
  <div class="metafield-edit-boolean">
    <BaseSwitcher
      :label="field.label"
      :value="valueParsed"
      @input="onInput"
      :trueLabel="subFormData.onVal"
      :falseLabel="subFormData.offVal"
      :hint="hint"
    />
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'
import { parseBooleanValue } from '@/helpers'

export default {
  mixins: [ forSingleMetafield(true) ],
  props: {
    value: [ Boolean, String ],
    field: Object,
    subFormData: Object,
    hint: String
  },
  computed: {
    valueParsed() {
      return parseBooleanValue(this.value)
    },
  },
  methods: {
    onInput (val) {
      this.$emit('input', String(val))
    }
  },
}
</script>

<style lang="scss">
  .metafield-edit-boolean {

  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditBoolean.vue